import React from 'react'

const IconDivider = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='32' height='16' viewBox='0 0 32 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <path d='M8 8H24' stroke={color} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
            <path
                d='M12 4H20'
                stroke='#7D7D7D'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeDasharray='2.5 2.5'
            />
            <path
                d='M12 12H20'
                stroke='#7D7D7D'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeDasharray='2.5 2.5'
            />
        </svg>
    )
}

export default IconDivider
